/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CreateGipAltReportMutationRequest, CreateGipAltReportMutationResponse, CreateGipAltReport400, CreateGipAltReport500 } from "../models/CreateGipAltReport";

export function getCreateGipAltReportUrl() {
  const res = { method: 'POST', url: `/reports/gip-alt/report` as const }
  return res
}

/**
 * @summary Create new report
 * {@link /reports/gip-alt/report}
 */
export async function createGipAltReport(data: CreateGipAltReportMutationRequest, config: Partial<RequestConfig<CreateGipAltReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateGipAltReportMutationResponse, ResponseErrorConfig<CreateGipAltReport400 | CreateGipAltReport500>, CreateGipAltReportMutationRequest>({ method : "POST", url : getCreateGipAltReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}